import { addMonths as n } from "./addMonths.js";
function d(t, o) {
  const r = o * 3;
  return n(t, r);
}
export {
  d as addQuarters,
  d as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/addQuarters.js
// module id = 1383
// module chunks = 67